/* funciona como coplemento, NO por si solo */
import Navegation from './Navegation.vue';

export const SHOW_ALL_PAGE_SIZE = 10000;
const FIXED_PAGE_SIZES = [10, 25, SHOW_ALL_PAGE_SIZE];

export default {
  components:{Navegation},
  data() {
    return {
      $store:this.$store,
      page:null,
      /* nav: {page:1,page_size:10,count:0}, */
      navegation:{page:1,page_size:10,default:true},
    };
  },
  computed: {
    navegations_keys(){ return Object.keys(this.$store.getters.navegations) },
    navegations(){ return this.$store.getters.navegations },
  },
  created () {
    const v = this.myRequestStatus.rq;
    v && v.then && v.then(r => this.thenGetRowsNavegation(r));
  },
  watch:{
    /* 'requestStatus'(v){
      if (v.indexOf(this.navegation) === -1) {
        if (v.find(v => v.name === this.name_all_computed)) this.nav = this.retNav();
      }
    }, */
    'requestStatusRq'(v){
      v.then && v.then(r => this.thenGetRowsNavegation(r));
    },
		'navegation.page_size'(val){
			this.filters.page_size = val;
			this.pageChange(1)
    },
  },
  methods: {
    retNav() {
      return this.navegations[this.customGets || this.name_all_computed/*  this.name+'/all' */];// || {page:1,page_size:10,count:0}
    },
    isLegacyShowAll(pageSize, count) {
      // Old "Todas" set page_size = count. Detect that (and ignore normal 10/25).
      return pageSize > 0
        && count > 0
        && pageSize === count
        && !FIXED_PAGE_SIZES.includes(pageSize);
    },
    thenGetRowsNavegation(r){
      if (r && r.results) {
        if (this.navegation.default) this.navegation = this.retNav();
        const previousCount = this.navegation.count;
        const previousPageSize = this.navegation.page_size;

        this.navegation.count = r.count;

        // Migrate sessions that selected "Todas" under the old count-bound option.
        if (this.isLegacyShowAll(previousPageSize, previousCount)
          && this.navegation.page_size !== SHOW_ALL_PAGE_SIZE) {
          this.navegation.page_size = SHOW_ALL_PAGE_SIZE;
          // page_size watcher will refetch with the fixed show-all size
        }

        this.navegation.pages = this.navegation.count / this.navegation.page_size;
        //this.navegation.pages = r.count / this.navegation.page_size;
        /* this.navegation.page = this.filters.page || 1; */
        if (this.page) this.navegation.page = this.page;
        this.page = null;  //si se destruye el componenete antes q se ejecute esto, podria dar problemas con el #de pagina?        
      }
      return r;
    },
    pageChange(page){
      this.page = page;
      this.navegation.page = page;
      //const rq_filter = JSON.parse(JSON.stringify(this.requestStatus.filter || {}));
      const rq_filter = this.myRequestStatus_filter || {};
      /* delete rq_filter.page; */
      Object.assign(rq_filter,{page});
      Object.assign(this.filters, /* {page}, */ rq_filter);
      return this.request();
		},
  }
}
